import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { FilterDashboardComptesUtilisateurs } from 'components/Comptes/Dashboard/DashboardHeader/types';

interface ComptesUtilisateursFilterContextContent {
  filter: Partial<FilterDashboardComptesUtilisateurs>;
  setFilter: Dispatch<
    SetStateAction<Partial<FilterDashboardComptesUtilisateurs>>
  >;
}

const ComptesUtilisateursFilterContext =
  createContext<ComptesUtilisateursFilterContextContent | null>(null);

export const useComptesUtilisateursFilterContext = (): [
  Partial<FilterDashboardComptesUtilisateurs>,
  Dispatch<SetStateAction<Partial<FilterDashboardComptesUtilisateurs>>>,
] => {
  const context = useContext(ComptesUtilisateursFilterContext);
  if (context === null) {
    throw new Error('useFilterContext called outside Context.');
  }

  return [context.filter, context.setFilter];
};

const ComptesUtilisateursFilterProvider =
  ComptesUtilisateursFilterContext.Provider;

export default ComptesUtilisateursFilterProvider;
